import React, { useState } from 'react';
import { TruckIcon, XIcon, CheckIcon, SearchIcon } from 'lucide-react';
interface TruckSelectorProps {
  currentTruckNumber: string;
  onTruckChange: (truckNumber: string) => void;
  onClose: () => void;
}
export const TruckSelector = ({
  currentTruckNumber,
  onTruckChange,
  onClose
}: TruckSelectorProps) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [manualEntry, setManualEntry] = useState('');
  const [showManualEntry, setShowManualEntry] = useState(false);
  // Sample truck data - in a real app, this would come from your API
  const availableTrucks = [{
    id: '1',
    number: 'T-001',
    type: 'Dump Truck 12'
  }, {
    id: '2',
    number: 'T-002',
    type: 'Strong Arm 14'
  }, {
    id: '3',
    number: 'T-003',
    type: 'Side Dump'
  }, {
    id: '4',
    number: 'T-004',
    type: 'Dump Truck 10'
  }, {
    id: '5',
    number: 'T-005',
    type: 'Dump Truck 14+'
  }, {
    id: '6',
    number: 'T-006',
    type: 'Strong Arm 12'
  }, {
    id: '7',
    number: 'T-007',
    type: 'Strong Arm 16+'
  }, {
    id: '8',
    number: 'T-008',
    type: 'Super Side 30tn+'
  }, {
    id: '9',
    number: 'T-009',
    type: 'Jumbo Side 35tn+'
  }, {
    id: '10',
    number: 'T-010',
    type: 'Belly Dump'
  }];
  const filteredTrucks = availableTrucks.filter(truck => truck.number.toLowerCase().includes(searchQuery.toLowerCase()) || truck.type.toLowerCase().includes(searchQuery.toLowerCase()));
  const handleManualSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (manualEntry.trim()) {
      onTruckChange(manualEntry.trim());
    }
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-2808">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md" data-id="element-2809">
        <div className="p-4 border-b flex justify-between items-center" data-id="element-2810">
          <h3 className="text-lg font-medium flex items-center gap-2" data-id="element-2811">
            <TruckIcon size={18} className="text-blue-600" data-id="element-2812" />
            Change Truck
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 p-1 rounded-full hover:bg-gray-100" data-id="element-2813">
            <XIcon size={18} data-id="element-2814" />
          </button>
        </div>
        <div className="p-4" data-id="element-2815">
          <div className="mb-4 relative" data-id="element-2816">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2817">
              <SearchIcon size={16} className="text-gray-400" data-id="element-2818" />
            </div>
            <input type="text" placeholder="Search trucks..." className="pl-10 pr-4 py-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-2819" />
          </div>
          <div className="max-h-60 overflow-y-auto mb-4 border rounded-md divide-y" data-id="element-2820">
            {filteredTrucks.length > 0 ? filteredTrucks.map(truck => <div key={truck.id} className={`p-3 flex items-center justify-between cursor-pointer hover:bg-gray-50 ${currentTruckNumber === truck.number ? 'bg-blue-50' : ''}`} onClick={() => onTruckChange(truck.number)} data-id="element-2821">
                  <div className="flex items-center gap-3" data-id="element-2822">
                    <TruckIcon size={16} className="text-gray-500" data-id="element-2823" />
                    <div data-id="element-2824">
                      <div className="font-medium" data-id="element-2825">{truck.number}</div>
                      <div className="text-xs text-gray-500" data-id="element-2826">{truck.type}</div>
                    </div>
                  </div>
                  {currentTruckNumber === truck.number && <CheckIcon size={16} className="text-blue-600" data-id="element-2827" />}
                </div>) : <div className="p-4 text-center text-gray-500" data-id="element-2828">
                No trucks found. Try another search or enter manually.
              </div>}
          </div>
          {showManualEntry ? <form onSubmit={handleManualSubmit} className="mb-4" data-id="element-2829">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2830">
                Enter truck number manually:
              </label>
              <div className="flex gap-2" data-id="element-2831">
                <input type="text" className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="e.g., T-123" value={manualEntry} onChange={e => setManualEntry(e.target.value)} autoFocus data-id="element-2832" />
                <button type="submit" className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md" data-id="element-2833">
                  Save
                </button>
              </div>
            </form> : <button onClick={() => setShowManualEntry(true)} className="text-blue-600 hover:text-blue-800 text-sm font-medium w-full text-center py-2 border border-blue-300 rounded-md hover:bg-blue-50 mb-4" data-id="element-2834">
              Enter Truck Number Manually
            </button>}
          <div className="flex justify-end" data-id="element-2835">
            <button onClick={onClose} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50" data-id="element-2836">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>;
};